export interface IConfirmableInjectedAction {
  performActionAfterConfirm: (formData, bindObj, action) => void;
}

